import store from '@/store/index';
import moment from 'moment';

export function getToken() {
  const tokenString = localStorage.getItem('token');
  if (tokenString) {
    const { token, expireTime } = JSON.parse(tokenString);
    const now = new Date().getTime();
    if (expireTime >= now) {
      return token;
    } else {
      removeToken();
      return null;
    }
  } else {
    const tempToken = sessionStorage.getItem('token');
    if (tempToken) {
      return tempToken;
    } else {
      removeToken();
      return null;
    }
  }
}

export function setToken(token: string, remember: boolean) {
  if (remember) {
    removeToken();
    const expireTime = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;
    localStorage.setItem('token', JSON.stringify({ token, expireTime }));
  } else {
    removeToken();
    sessionStorage.setItem('token', token);
  }
}

export function removeToken() {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
}

export function getSchoolInfo() {
  const schoolInfo = sessionStorage.getItem('schoolInfo');
  if (schoolInfo) {
    return JSON.parse(schoolInfo);
  } else {
    return null;
  }
}

export function getUserInfo() {
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    return JSON.parse(userInfo);
  } else {
    return null;
  }
}

export function setSchoolInfo(schoolInfo: any) {
  removeSchoolInfo();
  sessionStorage.setItem('schoolInfo', JSON.stringify(schoolInfo));
}

export function setUserInfo(userInfo: any) {
  removeUserInfo();
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
}

export function removeSchoolInfo() {
  sessionStorage.removeItem('schoolInfo');
}

export function removeUserInfo() {
  localStorage.removeItem('userInfo');
}

export function getRoleType() {
  return localStorage.getItem('roleType');
}

export function setRoleType(roleType: string) {
  removeRoleType();
  localStorage.setItem('roleType', roleType);
}

export function removeRoleType() {
  localStorage.removeItem('roleType');
}

export function getLocale() {
  return localStorage.getItem('locale');
}

export function setLocale(locale: string) {
  return localStorage.setItem('locale', locale);
}

export function fixIOSScroll(): void {
  const ua = window.navigator.userAgent;
  if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    window.scroll(0, 0);
  }
}

export function isWechat(): boolean {
  const ua = navigator.userAgent;
  return !!/MicroMessenger/i.test(ua);
}

export function formatCurrency(text: number): string {
  return Number(text).toLocaleString('en-US', { minimumFractionDigits: 2 });
}

export function formatTreeData(arr: any): any {
  const tmp = [] as Array<string>;
  for (const item of arr) {
    tmp.push({ ...item, children: item.children.length ? formatTreeData(item.children) : null });
  }
  return tmp;
}

export function backToLogin() {
  const router = store.state.router;
  if (router) {
    router.push({ name: 'login' });
  }
}
export function debounce(fn: any, delay = 1000) {
  let preTimeStamp = new Date().getTime();
  let currentTimeStamp = preTimeStamp;
  let content: any = null;
  let arg: any = null;
  let sto: any = null;

  const run = () => {
    preTimeStamp = new Date().getTime();
    sto = setTimeout(() => {
      fn.apply(content, arg);
    }, delay);
  };

  const clear = () => {
    clearTimeout(sto);
    run();
  };

  return function (this) {
    currentTimeStamp = new Date().getTime();
    content = this;
    arg = arguments;
    currentTimeStamp - delay > preTimeStamp ? run() : clear();
  };
}
export function getSchoolList() {
  const schoolList = sessionStorage.getItem('schoolList');
  if (schoolList) {
    return JSON.parse(schoolList);
  } else {
    return null;
  }
}

export function setSchoolList(schoolList: any) {
  removeSchoolList();
  sessionStorage.setItem('schoolList', JSON.stringify(schoolList));
}

export function removeSchoolList() {
  sessionStorage.removeItem('schoolList');
}
export function getSchoolId(): string {
  return getSchoolInfo().schoolId.toString();
}


export function formatGuardianData(values: any) {
  return {
    name: values.guardianName,
    enName: values.guardianEnName,
    mobile: values.guardianMobile,
    relationship: values.guardianRelationship,
    idNumber: values.guardianIdNumber,
    countryId: values.guardianCountryId,
    workUnit: values.guardianWorkUnit,
    workAddress: values.guardianWorkAddress,
    position: values.guardianPosition,
    email: values.guardianEmail,
    graduatedFrom: values.guardianGraduatedFrom,
    highestQualification: values.guardianHighestQualification,
  };
}

export function formatEmergencyData(values: any) {
  return {
    name: values.emergencyName,
    relationship: values.emergencyRelationship,
    mobile: values.emergencyMobile,
    email: values.emergencyEmail,
  };
}

export function formatValuesInParentInfo(userInfo: any) {
  const guardianResponse = userInfo.guardianResponse ? userInfo.guardianResponse : {};
  const emergencyContactResponse = userInfo.emergencyContactResponse ? userInfo.emergencyContactResponse : {};
  return {
    mobile: userInfo.mobile,
    name: userInfo.name,
    enName: userInfo.enName,
    countryId: userInfo.countryId ? userInfo.countryId : undefined,
    idNumber: userInfo.idNumber ? userInfo.idNumber : undefined,
    relationship: userInfo.relationship ? userInfo.relationship : undefined,
    email: userInfo.email,
    position: userInfo.position,
    workUnit: userInfo.workUnit,
    workAddress: userInfo.workAddress,
    sourceId: userInfo.sourceId,
    sourceExtra: userInfo.sourceExtra,
    graduatedFrom: userInfo.graduatedFrom,
    highestQualification: userInfo.highestQualification,
    accountMobile: userInfo.accountMobile,
    guardianName: guardianResponse.name,
    guardianEnName: guardianResponse.enName,
    guardianRelationship: guardianResponse.relationship,
    guardianGender: guardianResponse.gender,
    guardianCountryId: guardianResponse.countryId,
    guardianIdNumber: guardianResponse.idNumber,
    guardianMobile: guardianResponse.mobile,
    guardianWorkUnit: guardianResponse.workUnit,
    guardianWorkAddress: guardianResponse.workAddress,
    guardianPosition: guardianResponse.position,
    guardianEmail: guardianResponse.email,
    guardianGraduatedFrom: guardianResponse.graduatedFrom,
    guardianHighestQualification: guardianResponse.highestQualification,
    emergencyContactFlag: userInfo.emergencyContactFlag + '',
    emergencyName: emergencyContactResponse.name,
    emergencyRelationship: emergencyContactResponse.relationship,
    emergencyMobile: emergencyContactResponse.mobile,
    emergencyEmail: emergencyContactResponse.email,
  };
}
export function formatValuesInBaseInfo(values: any) {
  return {
    name: values.name ? values.name : undefined,
    enName: values.enName ? values.enName : undefined,
    pinyinLastName: values.pinyinLastName ? values.pinyinLastName : undefined,
    pinyinFirstName: values.pinyinFirstName ? values.pinyinFirstName : undefined,
    gender: values.gender ? values.gender : undefined,
    birthday: values.birthday ? moment(values.birthday) : undefined,
    idType: values.idType ? values.idType : undefined,
    idNumber: values.idNumber ? values.idNumber : undefined,
    countryId: values.countryId ? values.countryId : undefined,
    address: values.address ? values.address : undefined,
    domicileAddress: values.domicileAddress ? values.domicileAddress : undefined,
    campusId: values.campusId ? values.campusId : undefined,
    schoolYearId: values.schoolYearId && values.semesterId ? [values.schoolYearId, values.semesterId] : undefined,
    sectionId: values.sectionId ? values.sectionId : undefined,
    schoolNow: values.schoolNow ? values.schoolNow : undefined,
    schoolNowExtra: values.schoolNowExtra ? values.schoolNowExtra : undefined,
    schoolBus: values.schoolBus,
    boarding: values.boarding,
    english: values.english ? values.english : undefined,
    parentEnglishCommunicationFlag: values.parentEnglishCommunicationFlag ? values.parentEnglishCommunicationFlag : undefined,
    interest: values.interest ? values.interest : undefined,
    achievement: values.achievement ? values.achievement : undefined,
    citicBankAccIdNum: values.citicBankAccIdNum ? values.citicBankAccIdNum : undefined,
    citicBankAccName: values.citicBankAccName ? values.citicBankAccName : undefined,
    enterDate: values.enterDate ? moment(values.enterDate) : undefined,
    currentSectionId: values.currentSectionId ? values.currentSectionId : undefined,
  };
}